import {PromotionType} from "./PromotionType";

// Promotion types that are qualified as financial promotions in KM-112
const FINANCIAL_CTA_PROMOTION_TYPES: ReadonlySet<PromotionType> = new Set([
    PromotionType.PROMOTION,
    PromotionType.OPEN_DAYS,
    PromotionType.DISCOUNT,
    PromotionType.LAST_MINUTE,
    PromotionType.PRESALE,
    PromotionType.NO_CONTRIBUTION
]);

function isFinancialCtaPromotionType(type: number): boolean {
    return FINANCIAL_CTA_PROMOTION_TYPES.has(type as PromotionType);
}

interface IFinancialCtaPromotion {
    id: number;
    type: number;
    name: string;
    description: string | null;
}

export function pickFinancialCtaPromotion(...sources: (IFinancialCtaPromotion[] | null | undefined)[]) {
    for (const source of sources) {
        const match = source?.find((promotion) => isFinancialCtaPromotionType(promotion.type));

        if (match) {
            return match;
        }
    }

    return null;
}
import {PromotionType} from "./PromotionType";

// Promotion types that are qualified as financial promotions in KM-112
const FINANCIAL_CTA_PROMOTION_TYPES: ReadonlySet<PromotionType> = new Set([
    PromotionType.PROMOTION,
    PromotionType.OPEN_DAYS,
    PromotionType.DISCOUNT,
    PromotionType.LAST_MINUTE,
    PromotionType.PRESALE,
    PromotionType.NO_CONTRIBUTION
]);

function isFinancialCtaPromotionType(type: number): boolean {
    return FINANCIAL_CTA_PROMOTION_TYPES.has(type as PromotionType);
}

interface IFinancialCtaPromotion {
    id: number;
    type: number;
    name: string;
    description: string | null;
}

export function pickFinancialCtaPromotion(...sources: (IFinancialCtaPromotion[] | null | undefined)[]) {
    for (const source of sources) {
        const match = source?.find((promotion) => isFinancialCtaPromotionType(promotion.type));

        if (match) {
            return match;
        }
    }

    return null;
}
